const reportDB = require('../../../../../components/report/report-db')
const report   = require('../../../../../components/report/report')
const style    = require('../../../../../components/report/report-style')
const css      = style.get()

export function start(detail) {

    const phpFile = 'server/php/sql/report.php'
    detail.inf = { entity: 'customer', report: 'account-profit-period', id: detail.dbid, period: detail.period }

    reportDB.select(detail, phpFile, (data) => {

        insert(detail, data)

    })

}/**/


function insert(detail, data) { 

    report.show(detail, () => {

        const pageTarget = document.getElementById('report-page-right')
        const body       = generate(data)

        pageTarget.insertAdjacentHTML("beforeend", body)

    })

}/*insert*/



function generate(data) {

    var body = ''

    body += generateHeader()
    body += generateTop(data[0])
    body += generateTable(data)
    body += `</div> <!-- dataCont -->`
    body += `<div class="report-page">`

    return body
}

function generateHeader() {

    var header = ''
    header += `<div class="report-page" id="miDiv5" ${css.table}>`
    header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"customer", "elem":"report", "reportType":"profitsAll"} ] }' >
                                <svg fill="#ffffff" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M38.454,13.627c-0.759-0.804-2.024-0.839-2.827-0.081l-18,17C17.227,30.924,17,31.45,17,32s0.227,1.076,0.627,1.454l18,17 C36.013,50.819,36.507,51,37,51c0.531,0,1.061-0.21,1.455-0.627c0.758-0.803,0.722-2.069-0.081-2.827L21.913,32l16.46-15.546 C39.176,15.696,39.212,14.43,38.454,13.627z"></path> <path d="M32,0C23.453,0,15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.33,16.583,9.374,22.626 C15.417,60.671,23.453,64,32,64s16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.33-16.583-9.374-22.626 C48.583,3.329,40.547,0,32,0z M51.797,51.798C46.509,57.087,39.479,60,32,60s-14.509-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32 s2.913-14.51,8.203-19.798C17.491,6.913,24.521,4,32,4s14.509,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32 S57.087,46.51,51.797,51.798z"></path> </g> </g></svg>
                            </div>

                            <h1>All Customers Statement: Accounts Profits For A Customer And Period</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

    header += `
                    <div class="dataCont">
                        <h1  ${css.f32}></h1>
                        <p   ${css.f14} >
                                 </p>
            `
    return header


}


function generateTop(data) {
    var table = `<br><br><h1 style="text-align: center;">${data.company_name}</h1>
      <h2 style="text-align: center;">Accounts Profits Per Period As Of ${data.current_dateTime}</h2>
      <h2 style="text-align: center;"></h2>
      `;


    return table

}/**/





function generateTable(data) {

    var totals = {
        total_earnings: 0
    };
    var nextFormat = 0;

    var table = `
    <h2 ${css.f15}>Invoice Breakdown for Customer ${data[0].customer_name} - ${data[0].period}: This is a financial document that provides information about money 
                                earned to a company by its customers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
       <th ${css.th}>Invoice Code</th>
       <th ${css.th}>Date</th>
       <th ${css.th}>Item</th>
       <th ${css.th}>QTY</th>
       <th ${css.th}>Unit Price</th>
       <th ${css.th}>Total Amount</th>
       <th ${css.th}>Profits</th>
     </tr> 
       `

    for (let i = 0; i < data.length; i++) {

        totals.total_earnings += parseFloat(data[i].earnings);

        let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"report",  "act":"jump", 
          "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${data[i].code}"  } ] }'`

        table += `
            <tr ${rowStyle(i)}>
              <td class='tdClick' ${css.td} ${detailHtml}>${data[i].code}</td>
              <td ${css.td}>${data[i].sale_date}</td>
              <td ${css.td}>${data[i].item_name}</td>
              <td ${css.td}>${data[i].qty}</td>
              <td ${css.td}>${cashVal(data[i].price)}</td>
              <td ${css.td}>${cashVal(data[i].amount)}</td>
              <td ${css.td}>${cashVal(parseFloat(data[i].earnings))}</td>
            </tr> 
        `
        nextFormat = i + 1;

    }

    //PRINITNG EACH COLUMM TOTAL
    table += `
        <tr ${rowStyle(nextFormat)}>
          <td style="text-align: right;" colspan="6"><h2>Total</h2></td>
          <td ${css.td} ><h3>${cashVal(totals.total_earnings)}</h3></td>
        </tr> 
        `

    table += `</table>`

    return table

}

function cashVal(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

    if (i % 2 === 0) { return '' }
    return css.trGray

}
